
export const landing = {
  hero: {
    title: "Reduce Bad Hires by 73%",
    subtitle: "Make data-driven hiring decisions with scientifically-validated assessments. Join 10,000+ teams who've improved performance and built stronger teams.",
    cta: "Start Assessment",
    trusted: "Trusted by Fortune 500 companies",
    noCard: "No credit card required",
    fastResults: "Results in 10 minutes"
  },
  companies: {
    title: "Trusted by industry leaders worldwide"
  },
  stats: {
    assessments: "50K+",
    assessmentsLabel: "Assessments Completed",
    reduction: "73%",
    reductionLabel: "Reduction in Bad Hires",
    rating: "4.9",
    ratingLabel: "Customer Rating"
  },
  customerSuccess: {
    title: "Real Results from Real Teams",
    subtitle: "Join thousands of organizations using our platform to build stronger, more effective teams",
    metrics: {
      performance: {
        value: "89%",
        label: "Improved Team Performance",
        description: "Teams report better collaboration"
      },
      professionals: {
        value: "10,000+",
        label: "Professionals Assessed",
        description: "Across 500+ companies"
      },
      satisfaction: {
        value: "4.9/5",
        label: "Customer Satisfaction",
        description: "Based on 2,000+ reviews"
      },
      time: {
        value: "10 min",
        label: "Average Completion Time",
        description: "Fast, actionable insights"
      }
    }
  },
  howItWorks: {
    title: "How It Works",
    subtitle: "Get actionable insights in 3 simple steps",
    steps: {
      assess: {
        title: "Start Assessment",
        description: "Complete our scientifically-validated behavioral and cognitive assessments in under 30 minutes."
      },
      results: {
        title: "Get Results",
        description: "Receive detailed personality profiles, cognitive abilities, and work style preferences with visual charts."
      },
      decisions: {
        title: "Make Decisions",
        description: "Use insights for hiring, team formation, development planning, and improved collaboration."
      }
    }
  },
  features: {
    title: "Why Choose Our Platform?",
    subtitle: "Science-backed assessments that deliver real results"
  },
  testimonials: {
    title: "What Our Customers Say",
    subtitle: "Hear from leaders who've transformed their teams with our platform"
  },
  finalCta: {
    title: "Ready to Transform Your Hiring?",
    subtitle: "Join 10,000+ teams using our platform to make better hiring decisions and build stronger teams.",
    cta: "Start Assessment Now",
    features: {
      noCard: "No credit card required",
      compliant: "GDPR compliant",
      fast: "Results in 10 minutes"
    }
  }
};
